export default "__VITE_ASSET__BrEK3w_E__"